import { setUserPermissions } from './set-user-permissions';

/** `PUT /client/:cid/users/:id/permissions {fleet: false}`. */
export const revokeFleetAccess = async (user_id: string): Promise<any> =>
  setUserPermissions(user_id, { fleet: false });
